import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
	formHeader: {
		display: "flex",
		flexDirection: "column",
		padding: "var(--formHeaderV) var(--formHeaderH)",
	},
}));
